import { currencyLabels, DEFAULT_FORMAT_FALLBACK } from './constants';
import { FormatCurrencyOptions } from './types';

export const formatCurrency = (options: FormatCurrencyOptions): string => {
  const {
    fallback = DEFAULT_FORMAT_FALLBACK,
    value
  } = options;
  const currency = value?.trim().toUpperCase() ?? '';

  if (!currency) return fallback;

  return currencyLabels[currency] ?? currency;
};